import { DataBean } from "../DataBean";


export class DOCDocumentVersion extends DataBean {

    public async addFileToRecordDocument(idEmployee: number, idDOCFileRecordDocument: number, title: string, description: string, media: string, mediaContext: string, metadata: Record<string, any>): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCDocument_addFileToRecordDocument_Number_Number_String_String_String_String_java.util.Map", [idEmployee, idDOCFileRecordDocument, title, description, media, mediaContext, metadata]);
    }

    public async getDOCDocumentVersionRender(page: number, rows: number, props: Record<string, any>): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.shared.Report_getDOCDocumentVersionRender_Number_Number_java.util.Map", [page, rows, props]);
    }

    public async getDOCDocumentVersion(iddocdocumentversion: number): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCDocumentVersion_getDOCDocumentVersion_Number", [iddocdocumentversion]);
    }

    public async getDOCDocumentVersionCatalogPorPropiedades(propiedades: Record<string, any>, maxRows: number): Promise<any> {
        return this.getCustomService("Forms", "java.util.List_getDOCDocumentVersionCatalogPorPropiedades_java.util.Map_Number", [propiedades, maxRows]);
    }

    public async updateDOCDocumentVersion(bean: Record<string, any>): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCDocumentVersion_updateDOCDocumentVersion_com.advantage.forms.bean.DOCDocumentVersion", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.advantage.forms.bean.DOCDocumentVersion"
            }
        ]);
    }

}
